import { getFeatureConfig } from '@luna/feature-config';

import { replaceThousandSeparatorToDecimal } from './amountFormattingService';

export const parseMaskedAmount = (value: string, precision: number) => {
    const rawVal = value.toString().trim();
    const val = replaceThousandSeparatorToDecimal(rawVal);
    let amount;
    let tailLength = 0;
    const balVal = val.replace(
        new RegExp(`\\${getFeatureConfig((config) => config.base.thousandSeparator)}`, 'gi'),
        '',
    );
    const afterSplit = balVal.split(getFeatureConfig((config) => config.base.decimalSeparator));
    let head = afterSplit[0];
    const tail = afterSplit[1];

    if (typeof tail !== 'undefined') {
        tailLength = afterSplit[1].length;
    }

    if (tailLength >= precision) {
        head += tail.substr(0, precision);
        amount = Number(head);
    } else {
        head += (tail || '').padEnd(precision, '0');
        amount = Number(head);
    }

    return amount;
};
